module.exports = __webpack_public_path__ + "img/prozess-logo.7a7ee713.png";